import { Controller } from "react-hook-form";
import React, { Fragment } from "react";
import Select from "react-select";
import { formatGroupLabel } from "root/ReactHookForm/ui/DropdownDataProviders";

export const CommonDropdown = ( { items, control, name, rules, placeholder, isSearchable, isClearable, isMulti, readOnly } ) =>
{
    return (
        <Controller
            control={ control }
            name={ name }
            rules={ rules }
            render={ ( {
                           field: { onChange, value, name, ref },
                           fieldState: { invalid, isTouched, isDirty, error },
                           formState
                       } ) => (
                <Fragment>
                    { readOnly !== true && <Select
                        placeholder={ placeholder }
                        onChange={ onChange }
                        defaultValue={ value }
                        options={ items }
                        isSearchable={ isSearchable }
                        isClearable={ isClearable }
                        isMulti={ isMulti }
                        formatGroupLabel={ formatGroupLabel }/> }
                    { readOnly === true && <input className='form-control' readOnly={ readOnly } defaultValue={ value.label }/> }
                </Fragment>
            ) }/>
    )
}